import {actions} from '../actions';

export default function rootReducer(appReducer) {
  const initialState = appReducer(undefined, {});

  return (state = initialState, action) => {
    switch (action.type) {
      case actions.ROOT.RESET: {
        return {...initialState};
      }

      case actions.ROOT.SET: {
        return {...action.payload.state};
      }

      default: {
        return appReducer(state, action);
      }
    }
  };
}
